import { render, staticRenderFns } from "./AdvancedCusSingleTransactionsList.vue?vue&type=template&id=38535724&"
import script from "./AdvancedCusSingleTransactionsList.vue?vue&type=script&lang=js&"
export * from "./AdvancedCusSingleTransactionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports